import { Container } from './BaseBannerInnerPages.style';

export default Container;
